// 시안 mdRender 를 React 로 — 제목(#·##·###), 목록(- ·*), 굵게(**), 이미지 줄(![](url)) 만 다룬다.
// 문자열을 HTML 로 꽂지 않으므로 따로 이스케이프할 것이 없다.
import { Fragment } from "react";
import { fileUrl } from "./api";

function inline(text, key) {
    const parts = text.split(/\*\*(.+?)\*\*/g);
    return parts.map((p, i) => (i % 2 ? <b key={`${key}-${i}`}>{p}</b> : <Fragment key={`${key}-${i}`}>{p}</Fragment>));
}

export default function MdPreview({ src }) {
    if (!String(src || "").trim()) return <span style={{ color: "var(--tx3)" }}>내용이 없습니다</span>;
    const out = [];
    let list = null;
    const flush = () => { if (list) { out.push(<ul key={`ul${out.length}`}>{list}</ul>); list = null; } };
    String(src).split("\n").forEach((l, i) => {
        const li = l.match(/^\s*[-*] (.*)/);
        if (li) { (list = list || []).push(<li key={i}>{inline(li[1], i)}</li>); return; }
        flush();
        const img = l.match(/^!\[.*\]\((.*)\)/);
        if (/^### /.test(l)) out.push(<h3 key={i}>{inline(l.slice(4), i)}</h3>);
        else if (/^## /.test(l)) out.push(<h2 key={i}>{inline(l.slice(3), i)}</h2>);
        else if (/^# /.test(l)) out.push(<h2 key={i}>{inline(l.slice(2), i)}</h2>);
        else if (img) {
            out.push(img[1]
                ? <div key={i} className="nt-img"><img src={fileUrl(img[1])} alt="본문 이미지" /></div>
                : <div key={i} className="mdimg"><i className="fa-regular fa-image"></i>이미지</div>);
        } else if (!l.trim()) out.push(<br key={i} />);
        else out.push(<div key={i}>{inline(l, i)}</div>);
    });
    flush();
    return <>{out}</>;
}
